module.exports = __webpack_public_path__ + "m-fcbdfd1c2599fc61c722845a2d676ea4.png";